import React, { useState, useEffect } from 'react';
import { Layout, Menu, theme, Button, Dropdown, message } from 'antd';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { 
  DashboardOutlined, 
  UploadOutlined, 
  FileOutlined, 
  CopyOutlined,
  SwapOutlined,
  UserOutlined,
  LogoutOutlined,
  TeamOutlined
} from '@ant-design/icons';
import api from '../services/api';

const { Header, Content, Sider, Footer } = Layout;

const AppLayout: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [userRole, setUserRole] = useState<string>('');

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  // 获取当前用户角色
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await api.get('/me');
        setUserRole(res.data.role || '');
      } catch (e) {
        // 忽略
      }
    };
    fetchUser();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('zhishentong_token');
    message.success('已退出登录');
    navigate('/login');
  };

  const menuItems = [
    // 仅管理员可见：用户管理
    ...(userRole === 'admin' ? [{
      key: '/admin/users',
      icon: <TeamOutlined />,
      label: '用户管理',
      onClick: () => navigate('/admin/users'),
    }] : []),
    {
      key: '/dashboard',
      icon: <DashboardOutlined />,
      label: <Link to="/dashboard">工作台</Link>,
    },
    {
      key: '/upload',
      icon: <UploadOutlined />,
      label: <Link to="/upload">上传合同</Link>,
    },
    {
      key: '/contracts',
      icon: <FileOutlined />,
      label: <Link to="/contracts">合同管理</Link>,
    },
    {
      key: '/compare',
      icon: <SwapOutlined />,
      label: <Link to="/compare">合同比对</Link>,
    },
    {
      key: '/templates',
      icon: <CopyOutlined />,
      label: <Link to="/templates">合同模板</Link>,
    },
  ];

  const userMenuItems = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: handleLogout,
    },
  ];

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ color: 'white', fontSize: '20px', fontWeight: 'bold' }}>
          智审通
        </div>
        <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
          <Button type="text" style={{ color: 'white' }} icon={<UserOutlined />}>
            {userRole === 'admin' ? '管理员' : '用户'}
          </Button>
        </Dropdown>
      </Header>
      <Layout>
        <Sider width={200} style={{ background: colorBgContainer }}>
          <Menu
            mode="inline"
            selectedKeys={[location.pathname]}
            style={{ height: '100%', borderRight: 0 }}
            items={menuItems}
          />
        </Sider>
        <Layout style={{ padding: '24px' }}>
          <Content
            style={{
              padding: 24,
              margin: 0,
              minHeight: 280,
              background: colorBgContainer,
            }}
          >
            <Outlet />
          </Content>
          <Footer style={{ textAlign: 'center', color: '#999', fontSize: 12 }}>
            智审通 ©2026 | 技术支持：779142413@qq.com | 电话：17812307315（微信同）
          </Footer>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default AppLayout;